/* 🤖 this file was generated by script */
export const wiconMenu01 = {
  name: 'menu_01',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12h18M3 6h18M3 18h18"/></svg>`,
};
